import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Box, IconButton, Typography, CircularProgress
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { userService } from '../../services/api';
import { useToast } from '../../context/ToastContext';

const StatusChangeModal = ({ open, onClose, userId, action, onSuccess }) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);

    const getActionText = () => {
        switch (action) {
            case 'activate':
                return 'activate';
            case 'deactivate':
                return 'deactivate';
            case 'resend_invite':
                return 'reinvite';
            case 'delete':
                return 'delete';
            default:
                return 'update';
        }
    };

    const handleConfirm = async () => {
        try {
            setLoading(true);
            
            let response;
            if (action === 'delete') {
                response = await userService.deleteUser(userId);
            } else {
                response = await userService.changeUserStatus(userId, action);
            }

            if (response.data.status === 'ok') {
                if (onSuccess) onSuccess();
            }
        } catch (error) {
            console.error(`Error ${getActionText()}ing user:`, error);
            showToast(error.response?.data?.message || `Failed to ${getActionText()} user`, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm">
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">{getActionText().charAt(0).toUpperCase() + getActionText().slice(1)} User</Typography>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Typography>
                    Are you sure you want to {getActionText()} this user?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button 
                    onClick={handleConfirm} 
                    variant="contained" 
                    color={'primary'}
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={20} />}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StatusChangeModal;
